module.exports = __webpack_public_path__ + "img/c04_unitspearman_Normal_ua.5465ec3d.webp";